import apiService from '../Api'
import { IGem, IGemStorePayload, IGemUpdatePayload } from './interfaces'

export default class GemsService {
  async list(): Promise<{ gems: IGem[] }> {
    return apiService.get(`/gems`).then((response) => response.data)
  }

  async show(id: number): Promise<{ gem: IGem }> {
    return apiService.get(`/gems/${id}`).then((response) => response.data)
  }

  async store(data: IGemStorePayload): Promise<{ message: string; gem: IGem }> {
    return apiService.post(`/gems`, data).then((response) => response.data)
  }

  async update(id: number, data: IGemUpdatePayload): Promise<{ message: string; gem: IGem }> {
    return apiService.put(`/gems/${id}`, data).then((response) => response.data)
  }

  async delete(id: number): Promise<{ message: string }> {
    return apiService.delete(`/gems/${id}`).then((response) => response.data)
  }
}
